const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - 購物廣告設定',
};

export default pageTitle;
